import clsx from 'clsx';

/**
 * Pill — neutral subtle tag for tech labels, categories.
 * (Decorative; Badge is semantic/status.)
 *
 * Props:
 *   dotColor - optional inline color for a leading dot (one of the few legit dynamic colors)
 *   icon     - optional leading icon
 */
export function Pill({ children, dotColor, icon, className = '' }) {
  return (
    <span className={clsx(
      'inline-flex items-center gap-1 px-2 py-0.5 bg-subtle border border-soft rounded-pill',
      'text-2xs font-medium text-body leading-tight whitespace-nowrap font-sans',
      className,
    )}>
      {dotColor && (
        <span
          className="w-1 h-1 rounded-full shrink-0"
          style={{ background: dotColor }}
        />
      )}
      {icon}
      {children}
    </span>
  );
}
